module.exports = __webpack_public_path__ + "media/images/pages/linkedin-e22ad13b14c3c538eeddc5250f26da5b.png";